export const AUTH_ACTION_TYPE = {
ACTION_SIGN_IN: "SIGN_IN",
ACTION_SIGN_UP: "SIGN_UP", 
FAILED_ATTEMPT: "FAILED", 
ACTION_LOG_OUT: "LOGGEDOUT"
}